import React, { useState, useEffect } from 'react';
import IconRenderer from '../../ui/IconRenderer';
import { calculateCourseCost, getCookbookCost } from '../../../config/contentPricingConfig';
import './ExploreFront.css';

const ExploreFront = ({
  templates,
  currentIndex,
  onCardClick,
  onNext,
  onPrevious,
  onShuffle,
  language
}) => {
  const currentTemplate = templates[currentIndex];

  if (!currentTemplate) {
    return (
      <div className="explore-front-empty">
        <p>No templates available</p>
      </div>
    );
  }

  const cost = currentTemplate.type === 'cookbook'
    ? getCookbookCost(false)
    : calculateCourseCost('beginner'); // Default to beginner cost

  return (
    <div className="explore-front-container">
      <div className="explore-front-card-wrapper">
        <button
          type="button"
          className="explore-front-card"
          onClick={onCardClick}
        >
          <div className="explore-front-card-content">
            <div className="explore-front-card-header">
              <div className="explore-front-card-icon-wrapper">
                <IconRenderer
                  name={language.toLowerCase()}
                  type="language"
                  size="small"
                  className="explore-front-language-icon"
                />
              </div>
              <div className="explore-front-card-title-wrapper">
                <div className="explore-front-card-title-row">
                  <h4 className="explore-front-card-title">{currentTemplate.title}</h4>
                </div>
              </div>
            </div>
            <p className="explore-front-card-description">{currentTemplate.description}</p>
            <div className="explore-front-card-footer">
              <span className="explore-front-card-type">
                {currentTemplate.type === 'cookbook' ? 'Cookbook' : 'Course'}
              </span>
              <span className="explore-front-card-cost">
                {cost} tokens
              </span>
            </div>
          </div>
        </button>
      </div>

      {/* Navigation Controls */}
      <div className="explore-front-navigation">
        <button
          type="button"
          className="explore-front-nav-btn explore-front-nav-btn--prev"
          onClick={onPrevious}
          disabled={templates.length <= 1}
          aria-label="Previous card"
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>

        <div className="explore-front-nav-indicator">
          <span className="explore-front-nav-current">{currentIndex + 1}</span>
          <span className="explore-front-nav-separator">/</span>
          <span className="explore-front-nav-total">{templates.length}</span>
        </div>

        {/* <button
          type="button"
          className="explore-front-nav-btn explore-front-nav-btn--shuffle"
          onClick={onShuffle}
          aria-label="Shuffle cards"
          title="Shuffle"
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M16 3h5v5M21 3l-5 5M8 21H3v-5M3 21l5-5M14 6l-4 4M10 6l4 4M14 18l-4-4M10 18l4-4" />
          </svg>
        </button> */}

        <button
          type="button"
          className="explore-front-nav-btn explore-front-nav-btn--next"
          onClick={onNext}
          disabled={templates.length <= 1}
          aria-label="Next card"
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ExploreFront;

